( function() {
	function matchRowHeights() {
		const stickyRows = document.querySelectorAll( '.comparison-table__fixed .comparison-row' );
		const slides = document.querySelectorAll( '.comparison-table__slider .swiper-slide' );

		console.log( 'stickyRows', stickyRows );

		// 1) Reset row heights to 'auto' (or '')
		stickyRows.forEach( row => row.style.height = '' );
		slides.forEach( slide => {
			slide.querySelectorAll( '.comparison-row' ).forEach( row => {
				row.style.height = '';
			} );
		} );

		// 2) Now measure each row index and set the max height
		stickyRows.forEach( ( stickyRow, i ) => {
			let maxHeight = stickyRow.offsetHeight;

			slides.forEach( slide => {
				const matchingRow = slide.querySelectorAll( '.comparison-row' )[ i ];
				if ( matchingRow ) {
					maxHeight = Math.max( maxHeight, matchingRow.offsetHeight );
				} else {
					console.log( 'Found no matching row', i, slide );
				}
			} );

			// 3) Apply the new max height
			stickyRow.style.height = maxHeight + 'px';
			slides.forEach( slide => {
				const matchingRow = slide.querySelectorAll( '.comparison-row' )[ i ];
				if ( matchingRow ) {
					matchingRow.style.height = maxHeight + 'px';
				} else {
					console.log( 'Found no matching row', i, slide );
				}
			} );
		} );
	}

	function initCollapsibleRows() {
		const fixedRows = document.querySelectorAll( '.comparison-table__fixed .comparison-row' );
		fixedRows.forEach( fixedRow => {
			fixedRow.addEventListener( 'click', () => {
				const rowIndex = fixedRow.dataset.rowIndex;

				// Toggle expanded class in the fixed column row
				fixedRow.classList.toggle( 'is-expanded' );

				// Toggle expanded class in the matching row(s) in each Swiper column
				// const matchingRows = document.querySelectorAll(
				// 	`.swiper-slide .comparison-row[data-row-index="${rowIndex}"]`
				// );
				// matchingRows.forEach( row => row.classList.toggle( 'is-expanded' ) );

				// Re-match heights after expansion/collapse
				matchRowHeights();
			} );
		} );
	}

	function initSliders() {

		const view = document.querySelector( '.product-comparison-view' );
		if ( !view ) {
			return;
		}

		const columnCount = + view.getAttribute( 'data-column-count' ) ?? 2;

		const mySwiper = new Swiper( '.comparison-table__slider', {
			slidesPerView: Math.min( columnCount, 2.2 ),
			on: {
				init: matchRowHeights
			},
			breakpoints: {
				900: {
					slidesPerView: Math.min( columnCount, 3.2 )
				},
				1200: {
					slidesPerView: Math.min( columnCount, 4.2 )
				},
			}
		} );

		window.addEventListener( 'resize', onResize );

		initCollapsibleRows();
		onResize();
	}

	function onResize() {
		if ( window.innerWidth < 768 ) {
			switchToMobileView();
		} else {
			switchToDesktopView();
			matchRowHeights();
		}
	}

	function switchToDesktopView() {
		const mobileView = document.querySelector( '.comparison-cards' );
		const desktopView = document.querySelector( '.comparison-table' );
		if ( !mobileView ) {
			return;
		}
		if ( desktopView ) {
			desktopView.style.display = 'flex';
			mobileView.style.display = 'none';
		}
	}

	function switchToMobileView() {
		if ( !prepareMobileView() ) {
			return;
		}

		const mobileView = document.querySelector( '.comparison-cards' );
		const desktopView = document.querySelector( '.comparison-table' );
		if ( mobileView ) {
			mobileView.style.display = 'flex';
		}
		if ( desktopView ) {
			desktopView.style.display = 'none';
		}
	}

	function toggleListItems( event, listItems, toggleLink, maxVisible, isExpandedRef ) {
		event.preventDefault();
		isExpandedRef.value = !isExpandedRef.value;

		for ( let i = maxVisible; i < listItems.length; i ++ ) {
			listItems[ i ].style.display = isExpandedRef.value ? '' : 'none';
		}

		const iconHtml = isExpandedRef.value
						 ? '<i class="fa-regular fa-minus"></i>'
						 : '<i class="fa-regular fa-plus"></i>';

		const linkText = isExpandedRef.value ? 'Show less features' : 'Show all features';
		toggleLink.innerHTML = `${iconHtml} ${linkText}`;

	}

	function getListShorteningToggle( ul, maxVisible = 4 ) {
		const listItems = Array.from( ul.querySelectorAll( 'li' ) );

		if ( listItems.length <= maxVisible ) return;

		// Hide items beyond the maxVisible count
		for ( let i = maxVisible; i < listItems.length; i ++ ) {
			listItems[ i ].style.display = 'none';
		}

		const isExpandedRef = { value: false }; // use object to pass by reference

		// Create toggle link
		const toggleLink = document.createElement( 'a' );
		toggleLink.href = '#';
		toggleLink.innerHTML = '<i class="fa-regular fa-plus"></i> Show all features';
		toggleLink.classList = 'toggle-features';

		toggleLink.addEventListener( 'click', ( event ) =>
			toggleListItems( event, listItems, toggleLink, maxVisible, isExpandedRef )
		);

		// Insert toggle link after the list
		return toggleLink;
	}

	/**
	 * Convert the comparison-table layout into "cards" for mobile.
	 * Assumes the markup structure you provided:
	 *  - .comparison-table__fixed for the left (sticky) column
	 *  - .comparison-table__slider (with .swiper-slide) for the product columns
	 */
	function prepareMobileView() {
		// 1) Grab the fixed column that holds the row labels
		const claims = document.querySelector( '.comparison-table__fixed' );
		if ( !claims ) return false;

		const mobile = document.querySelector( '.comparison-cards' );
		if ( mobile ) {
			return true;
		}

		// 2) Gather all the rows in the fixed column
		const fixedRows = claims.querySelectorAll( '.comparison-row' );

		// The first row (data-row-index="0") may be a heading like "Comparison"
		// so we skip it for feature labels:
		//   - row 0 is usually the big heading or product heading row
		//   - row 1..N are the features
		// We’ll store the feature labels by their data-row-index.
		const featureLabels = {};

		// Start from 1 if row-index=0 is just your "Comparison" heading.
		// Adjust if needed based on your markup.
		fixedRows.forEach( row => {
			const rowIndex = row.getAttribute( 'data-row-index' );
			if ( rowIndex === '0' ) {
				// probably the "Comparison" or heading row
				return;
			}
			const headerEl = row.querySelector( '.comparison-row .is-claim-label' );
			if ( headerEl ) {
				featureLabels[ rowIndex ] = headerEl.textContent.trim();
			}
		} );

		// 3) Grab each Swiper slide, which represents a single product column
		const slides = document.querySelectorAll( '.comparison-table__slider .swiper-slide' );
		if ( !slides.length ) return;

		// Create a container to hold our new “cards”
		const cardsContainer = document.createElement( 'div' );
		cardsContainer.className = 'comparison-cards';

		// 4) For each product slide, build a card
		slides.forEach( slide => {
			// The product name is typically in row-index="0" inside .comparison-row__product
			const productCell = slide.querySelector(
				'.comparison-row[data-row-index="0"] .comparison-row__product'
			);

			// Create the card element
			const card = productCell.cloneNode( true );
			card.className = 'card card--package';

			// List of features
			const featuresList = document.createElement( 'ul' );

			// 5) For each feature row in this slide (excluding row-index=0),
			//    create an <li> "Feature Label: Value"
			const productFeatureRows = slide.querySelectorAll(
				'.comparison-row:not([data-row-index="0"])'
			);
			productFeatureRows.forEach( featureRow => {
				const rowIndex = featureRow.getAttribute( 'data-row-index' );
				const valueEl = featureRow.querySelector( '.comparison-row__header.has-claim' );
				if ( !valueEl ) return; // skip if tag does not apply to current product

				const featureValue = valueEl.textContent.trim();
				const label = featureLabels[ rowIndex ] || 'Unknown Feature';

				const li = document.createElement( 'li' );
				// e.g. "WA Fundamentals Course 60 Hours: ✔"
				li.innerHTML = '<i class="fa-solid fa-circle-check"></i> ' + label;

				featuresList.appendChild( li );
			} );

			const toggle = getListShorteningToggle( featuresList );

			const pricingContainer = card.querySelector( '.pricing-container' );
			if ( pricingContainer ) {
				card.insertBefore( featuresList, pricingContainer );
				if ( toggle ) {
					card.insertBefore( toggle, pricingContainer );
				}
			} else {
				card.append( featuresList );
				if ( toggle ) {
					card.append( toggle );
				}
			}

			Array.from( card.children ).forEach( child => {
				child.classList.remove( 'has-text-align-center' );
				if ( child.classList.length === 0 ) {
					child.removeAttribute( 'class' );
				}
			} );

			cardsContainer.appendChild( card );
		} );

		// 6) Add the new cards container somewhere in the DOM.
		claims.closest( '.comparison-table' ).after( cardsContainer );

		// 7) Trigger affirm script to inject
		if ( typeof window.affirm !== 'undefined' ) {
			window.affirm.ui.ready( () => window.affirm.ui.refresh() );
		}

		return true;
	}

	// Example Swiper init
	window.addEventListener( 'load', () => {

		if ( typeof Swiper === 'undefined' ) {
			// Load Swiper script and styles dynamically
			var scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
			var styleUrl = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';

			var link = document.createElement( 'link' );
			link.rel = 'stylesheet';
			link.type = 'text/css';
			link.href = styleUrl;
			document.head.appendChild( link );

			var script = document.createElement( 'script' );
			script.src = scriptUrl;
			script.onload = initSliders;
			document.head.appendChild( script );
		} else {
			initSliders();
		}

	} );

} )();
